import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" {...props}>
      <defs>
        <style>
          {
            ".prefix__cls-1{fill:#8cdd79}.prefix__cls-2{fill:#7ece67}.prefix__cls-3{fill:#6ab891}.prefix__cls-4{fill:#4da67f}.prefix__cls-5{fill:#e2607f}.prefix__cls-6{fill:#e87092}.prefix__cls-7{fill:#e8677d}.prefix__cls-8{fill:#dd4e6a}.prefix__cls-9{fill:#d4d8e1}.prefix__cls-10{fill:#c7cdd8}"
          }
        </style>
      </defs>
      <title>{"Vegetable"}</title>
      <g id="prefix__Vegetable">
        <path
          className="prefix__cls-1"
          d="M75 45H25v-5.73c-.42-3.79 3.41-7.72 7.52-7.24-3.37-9.41 8.79-16.32 15.23-9a6 6 0 019.75-1 9 9 0 0117.22.75z"
        />
        <path
          className="prefix__cls-2"
          d="M89.52 44H26a9 9 0 0112.28-9.32 4 4 0 017.22-1.38 7 7 0 017.5-.09 9 9 0 1117.82 2.42A6 6 0 0179 41a8.93 8.93 0 0110.52 3z"
        />
        <path
          className="prefix__cls-2"
          d="M75 45H61.29l.17-5.8c2-8.39 6.23-14.86 12-19.22a8.86 8.86 0 011.26 2.82z"
        />
        <path
          className="prefix__cls-3"
          d="M105.71 28.18c-.06 1 .55-5.89-2.71 26.82H64l.45-15.4c2-8.55 6.94-15.55 14.55-19.6C94 12 98 4 98 4s8.61 10.25 7.71 24.18z"
        />
        <path
          className="prefix__cls-4"
          d="M72.89 45.89C76.47 33 89.21 31.15 94.09 20.58a1 1 0 011.82.84c-5.18 11.22-17.72 12.84-21.1 25a1 1 0 01-1.92-.53z"
        />
        <path
          className="prefix__cls-4"
          d="M105.71 28.18c-.06 1 .55-5.89-2.71 26.82H73.57l-.34-5.58c2.19-10.66 13.06-20.45 28.42-21 1.43-.04 2.78-.12 4.06-.24z"
        />
        <path
          className="prefix__cls-3"
          d="M118.71 55.43c-1.4 1.63-1.89 2-6.71 6.57H77l-.75-12.36c1.84-8.87 11.75-17.72 25.51-18.21 17-.59 24.1-6 24.1-6s4.14 16.77-7.15 30z"
        />
        <path
          className="prefix__cls-5"
          d="M38 62H6.09C-.38 44.84 21.2 31.16 34 44a17.16 17.16 0 013.8 5.79z"
        />
        <path
          className="prefix__cls-6"
          d="M23 59.87V62H10.47a13.06 13.06 0 01-1.05-9.3 3 3 0 015-1.41z"
        />
        <path
          className="prefix__cls-7"
          d="M23 59.83V62H10.47a12.87 12.87 0 01-1.31-4h12z"
        />
        <path
          className="prefix__cls-6"
          d="M34.49 52.41l-9.85 3.4-7.35-7.35a3 3 0 011.41-5 13 13 0 0115.79 8.95z"
        />
        <path
          className="prefix__cls-8"
          d="M23.18 62c0-2.28.1-2.07 0-2.17l-1.89-1.89a19.52 19.52 0 01.2-5.46l3.33 3.33 9.85-3.4a13 13 0 00-9.07-8.95 20.87 20.87 0 013.16-3.14A17 17 0 0138 49.77L38.18 62z"
        />
        <path
          className="prefix__cls-7"
          d="M34.67 52.41l-9.85 3.4-3.33-3.33a19.76 19.76 0 014.11-9 13 13 0 019.07 8.93z"
        />
        <path
          className="prefix__cls-8"
          d="M10.47 62H6.09a16.93 16.93 0 01-1-4h4a12.87 12.87 0 001.38 4z"
        />
        <path
          className="prefix__cls-5"
          d="M57 62H25.09c-5.28-14 8.82-27.41 22.49-21.68a17 17 0 019.24 9.45z"
        />
        <path
          className="prefix__cls-6"
          d="M42 59.87V62H29.47a13.06 13.06 0 01-1-9.3 3 3 0 015-1.41z"
        />
        <path
          className="prefix__cls-7"
          d="M42 59.83V62H29.47a12.87 12.87 0 01-1.31-4h12z"
        />
        <path
          className="prefix__cls-6"
          d="M53.49 52.41l-9.85 3.4-7.35-7.35a3 3 0 011.41-5 13 13 0 0115.79 8.95z"
        />
        <path
          className="prefix__cls-8"
          d="M29.47 62h-4.38a16.93 16.93 0 01-1-4h4a12.87 12.87 0 001.38 4z"
        />
        <path className="prefix__cls-9" d="M91 110.91V124H37v-13.09" />
        <path className="prefix__cls-10" d="M91 119v5H37v-5" />
        <path
          className="prefix__cls-9"
          d="M1 62h126v4a46 46 0 01-46 46H47A46 46 0 011 66v-4z"
        />
        <path
          className="prefix__cls-10"
          d="M126.63 71.86A46 46 0 0181 112H47A46 46 0 011.37 71.86a46.39 46.39 0 0045 35.14h35.27a46.39 46.39 0 0044.99-35.14z"
        />
        <path
          className="prefix__cls-8"
          d="M42 62c0-2.28.1-2.07 0-2.17l-1.89-1.89a19.52 19.52 0 01.2-5.46l3.33 3.33 9.85-3.4a13 13 0 00-9.07-8.95 20.87 20.87 0 013.16-3.14 17 17 0 019.24 9.45L57 62z"
        />
        <path
          className="prefix__cls-7"
          d="M53.49 52.41l-9.85 3.4-3.33-3.33a19.76 19.76 0 014.11-9 13 13 0 019.07 8.93z"
        />
        <path
          className="prefix__cls-4"
          d="M78.89 55H64c.49-16.68.2-15.11 1.27-18.3a20.06 20.06 0 0113.34 12c.28.68.19-.39.28 6.3z"
        />
        <path
          className="prefix__cls-5"
          d="M76 62H44.09C37.62 44.84 59.2 31.16 72 44a17.16 17.16 0 013.8 5.79z"
        />
        <path
          className="prefix__cls-6"
          d="M61 59.87V62H48.47a13.06 13.06 0 01-1-9.3 3 3 0 015-1.41z"
        />
        <path
          className="prefix__cls-7"
          d="M61 59.83V62H48.47a12.87 12.87 0 01-1.31-4h12z"
        />
        <path
          className="prefix__cls-6"
          d="M72.49 52.41l-9.85 3.4-7.35-7.35a3 3 0 011.41-5 13 13 0 0115.79 8.95z"
        />
        <path
          className="prefix__cls-8"
          d="M61 62c0-2.28.1-2.07 0-2.17l-2.47-2.47a12.48 12.48 0 012-3.7l2.15 2.15 9.85-3.4c-1-3.51-2.26-3.5-.78-3.24a6.9 6.9 0 012.75-2.1 17.07 17.07 0 011.36 2.7L76 62z"
        />
        <path
          className="prefix__cls-7"
          d="M72.49 52.41l-9.85 3.4-2.15-2.15A12 12 0 0171 49.09a12.64 12.64 0 011.49 3.32zM61 59.87V62h-3a11.77 11.77 0 01.53-4.64z"
        />
        <path
          className="prefix__cls-4"
          d="M118.71 55.43c-1.4 1.63-1.89 2-6.71 6.57H77l-.75-12.36a16.74 16.74 0 011-3.12 6.91 6.91 0 013.85 1.19 9.88 9.88 0 013.24-.54c1.94 0 1.55.42 1.86-.25 5.23-10.16 20.42-8 22.49 3.31a9 9 0 017.47 5.18 12.14 12.14 0 012.55.02z"
        />
        <path
          className="prefix__cls-4"
          d="M101.65 43.91c4.83-1 9.38-2 13.41-5.33a1 1 0 011.26 1.56c-4.39 3.58-9.4 4.67-14.24 5.73a1 1 0 01-.43-1.96z"
        />
        <path
          className="prefix__cls-1"
          d="M124.52 62H61a9 9 0 0112.28-9.32 4 4 0 017.22-1.38 7 7 0 017.5-.09 9 9 0 1117.82 2.42A6 6 0 01114 59a8.93 8.93 0 0110.52 3z"
        />
        <path
          className="prefix__cls-2"
          d="M124.52 62H61a8.75 8.75 0 01.48-4h52.38a5.58 5.58 0 01.12 1 8.93 8.93 0 0110.54 3z"
        />
        <path
          className="prefix__cls-8"
          d="M48.47 62h-4.38a16.93 16.93 0 01-1-4h4a12.87 12.87 0 001.38 4zM61 58v1.83L59.17 58H61z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
